import { Stack } from '@mui/system';
import { useParams } from 'react-router-dom';
import BlogForm from './Forms/BlogForm';
import CategoryForm from './Forms/CategoryForm';
import EmailForm from './Forms/EmailForm';
import InstagramForm from './Forms/InstagramForm';
import ProductDescriptionForm from './Forms/ProductDescriptionForm';
import ReviewForm from './Forms/ReviewForm';
import RutubeForm from './Forms/RutubeForm';
import RutubeReviewForm from './Forms/RutubeReviewForm';
import ServiceForm from './Forms/ServiceForm';
import AIChatForm from './Forms/AIChatForm';

interface IInputProps {}

const Input: React.FC<IInputProps> = ({}) => {
  const { url } = useParams();

  return (
    <Stack
      sx={{
        flex: 1,
        p: {
          mobile: '40px 0 60px',
          laptop: '20px 0',
        },
        boxSizing: 'border-box',
        justifyContent: 'space-between',
      }}
    >
      {url === 'chat' && <AIChatForm />}

      {url === 'instagram' && <InstagramForm />}

      {url === 'blog' && <BlogForm />}

      {url === 'category' && <CategoryForm />}

      {url === 'website' && <ServiceForm />}

      {url === 'email' && <EmailForm />}

      {url === 'review' && <ReviewForm />}

      {url === 'product' && <ProductDescriptionForm />}

      {url === 'youtube' && <RutubeForm />}

      {url === 'youtube-review' && <RutubeReviewForm />}
    </Stack>
  );
};

export default Input;
